var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal" } }, [
    _c("div", { staticClass: "modal-mask" }, [
      _c("div", { staticClass: "modal-wrapper" }, [
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "justify-content": "center",
              "align-items": "center",
              width: "100%",
              height: "100%",
              color: "white"
            },
            on: {
              scroll: function($event) {
                $event.preventDefault()
                $event.stopPropagation()
              }
            }
          },
          [
            _c("h1", [_vm._v("現在処理中です、")]),
            _vm._v(" "),
            _c("h1", [_vm._v("しばらくお待ちください。")])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }